import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Button from '../Elements/Button/Button';
import { purifier, getCookie, setCookie } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './CookiesNotification.scss';

const CookiesNotification = ({ content, setup, cookieConsent }) => {
	const notifications = content.filter((n) => n?.text); // only notifications which are set.
	const [elementRemoved, removingElement] = useState(false);
	const [showCookieMessage, toggleCookieMessage] = useState(true);
	let isClosing = false;

	if (!showCookieMessage) {
		// Remove element
		isClosing = true;
		window.setTimeout(() => {
			removingElement(true);
			isClosing = false;
		}, 2000);

		if (elementRemoved) return null;
	}

	return (
		<div className={s.notification}>
			{
				notifications.map((item) => {
					if (item.countryRestrict && item.countryRestrict.indexOf(setup.country) === -1 && !item?.text) return null;
					const notificationName = urlify(item.name);
					const notificationInnerClasses = [s.notification_inner, (item.removeText ? [s.notification_inner__closeText] : null)];

					if (item.backgroundColor) notificationInnerClasses.push(s[`notification_inner__${item.backgroundColor.toLowerCase()}`]);

					// Check for cookies which are already set.
					if ((item.removable) && item.cookieDuration) {
						let cookieIsSet = false;

						const cookies = typeof document !== 'undefined' ? getCookie(notificationName) : setup.cookies;
						if (cookies && typeof cookies === 'object') {
							if (cookies[notificationName]) cookieIsSet = true;
						} else if (cookies) {
							cookieIsSet = true;
						}

						// Still render notification if from server and cookie not set on page load.
						// This enables us to fade it out.
						if (cookieIsSet && !isClosing) return null;
					}

					const removeNotificationHandler = (e) => {
						e.preventDefault();

						setCookie(notificationName, ['all'], item.cookieDuration);
						cookieConsent(['all']);

						if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
						window.dataLayer.push({
							event: 'CookiesPreferencesSet',
							values: {
								cookieSettings: ['all'],
							},
						});

						toggleCookieMessage(false);
					};

					return (
						<div key={notificationName} className={[...notificationInnerClasses, (!showCookieMessage ? s.notification_inner__exiting : null)].join(' ')}>
							<div className={s.notification_inner_container}>
								<span className={s.notification_inner_container_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, item?.text), { ALLOWED_TAGS: ['a'] }, setup) }} />
								<Button type="button" variantClasses={['button__inverted', 'button__leftAngle']} clickEventHandler={removeNotificationHandler}>{ translate(setup, item.removeText) }</Button>
							</div>
						</div>
					);
				})
			}
		</div>
	);
};

export default hot(module)(CookiesNotification);
